import React, { useState } from "react";
import { func, object } from "prop-types";

import { InputField } from "../../atoms/InputField";
import { translateError } from "../../utils";
import { sendOtp, resetPassword } from "@quintype/bridgekeeper-js";

import "./profile-page.m.css";
import Modal from "../../login/modal";
import { useTimer } from "../../atoms/timer";

const UpdatePassword = ({ onClose, member }) => {
  const [input, setInput] = useState("");
  const [otp, setOTP] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const { start, time } = useTimer();

  const { email } = member;

  const [error, setError] = useState({});

  const setData = (e) => {
    if (e.target.id === "otp") {
      setOTP(e.target.value);
    } else {
      setInput(e.target.value);
    }
  };

  const otpHandler = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!email) {
      setError({ message: "Sähköpostia ei ole linkitetty" });
      return null;
    }

    const body = { "always-send": true, email: email };

    try {
      const reponse = await sendOtp(body);
      if (reponse.status === 200) {
        setShowOtp(true);
        start(30);
        setError({});
      } else {
        const message = translateError(reponse.message);
        setError({ message: `${message}, Lähetä OTP uudelleen napsauttamalla Jatka` });
      }
    } catch (error) {
      setError({ message: translateError(error.message) });
    }
  };

  const updateHandler = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (input.length < 1 || otp.length < 1) {
      setError({ message: "Anna kelvolliset tiedot" });
      return null;
    }
    try {
      const body = {
        email: email,
        otp: otp,
        "new-password": input,
      };

      const response = await resetPassword(body);

      if (response.message) {
        onClose();
      } else {
        const message = translateError(response?.error?.message);
        setError({ message: message || "Error" });
      }
    } catch (err) {
      setError({ message: translateError(err.message) });
      console.warn("error", err);
    }
  };

  return (
    <Modal onClose={onClose} portalClassName="profile-page-modal-portal" closeIconColor="#000">
      <form styleName="malibu-form-link">
        <>
          <h3>Päivitä salasanasi</h3>
          {!showOtp ? (
            <>
              <p styleName="fields" style={{ color: "#000" }}>
                Kertakäyttösalasana eli OTP-koodi lähetetään sähköpostiosoitteeseen {member.email} vahvistusta varten.
              </p>
              {error && <p styleName="otp-error">{error.message}</p>}
              <button
                aria-label="login-button"
                onClick={otpHandler}
                styleName="btn-submit"
                className="malibu-btn-large"
                style={{ backgroundColor: "#ac3040" }}
              >
                Lähetä
              </button>
            </>
          ) : (
            <>
              <p styleName="fields" style={{ color: "#000" }}>Kertakäyttösalasana eli OTP-koodi on lähetetty sähköpostiosoitteeseen {member.email}.</p>
              <InputField name="OTP-koodi" id="otp" type="number" required onChange={setData} />
              <InputField name="Uusi salasana" id="password" type="password" required onChange={setData} />
              {error && <p styleName="otp-error">{error.message}</p>}
              <button
                aria-label="login-button"
                onClick={updateHandler}
                styleName="btn-submit"
                className="malibu-btn-large"
                style={{ backgroundColor: "#ac3040" }}
              >
                Päivitä salasana
              </button>
              <button
                disabled={time > 0}
                aria-label="resend-otp-button"
                onClick={otpHandler}
                styleName="resend-otp-btn"
              >
                Lähetä OTP-koodi uudelleen
              </button>
              {time > 0 && (
                <p styleName="resend-otp">
                  Lähetä OTP-koodi uudelleen <span>{`0.${time}`}</span> kuluttua.
                </p>
              )}
            </>
          )}
        </>
      </form>
    </Modal>
  );
};

UpdatePassword.propTypes = {
  onClose: func,
  member: object,
};

export default UpdatePassword;
